import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { googleAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        toast.error('Authentication failed');
        navigate('/login');
        return;
      }

      try {
        const result = await googleAuth(sessionId);
        toast.success('Successfully logged in!');
        // Redirect admin users to admin panel, others to dashboard
        if (result?.user?.role === 'admin') {
          navigate('/admin', { state: { user: true } });
        } else {
          navigate('/dashboard', { state: { user: true } });
        }
      } catch (error) {
        toast.error('Authentication failed');
        navigate('/login');
      }
    };

    processAuth();
  }, [location, googleAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-primary mx-auto mb-4" />
        <p className="text-neutral-300">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;